import mitt from 'mitt'
import { Events } from './models/events.model'

export const EventBus = mitt<Events>()
